export const Colors = {
  TRANSPARENT: '#00000000',
  DROPDOWN: '#020212',
  GRAY: '#D9D9D91A',
  GRAY2: '#E3E9F0',
  TEXT_COLOR: '#F7F6FD',
  TEXT_COLOR_BLUE: '#051655',
  TEXT_COLOR_PINK: '#D154FB',
  VIOLET_LIGHT: '#FF42F7',
  VIOLET: '#642bb0',
  BLUE: '#345DF4',
  WHITE: '#fff',
  PURPLESELECT: '#9747ffcc',
  BLACKTRANSPARENT: '#02021266',
  PINK: '#D154FB',
};
